import"react/jsx-runtime";import"@jobseeker/lotus/lib/assets/icons";import"next/image";import"@mui/material";import"@jobseeker/lotus/lib/elements/ButtonV2";import"@jobseeker/common-core/lib/utils/common";process.env.NEXT_PUBLIC_APP_NAME;
//# sourceMappingURL=index.js.map
